import * as angular from "angular";
import {CleverSchool} from "../models/school/clever-school.model";
import {NavianceSchool} from "../models/school/naviance-school.model";
import {AddressService} from "../services/address/address.service";

export class MatchDetailsController {
    navianceSchool: NavianceSchool;
    cleverSchool: CleverSchool;
    cleverUnmatchedSchools: CleverSchool[];
    searchFilterText = "";
    indexOfUnmatchedCleverSchool: number;
    cleverUnmatchedSchoolsList: CleverSchool[];
    selectedNewCleverSchool: boolean;
    onSchoolUnmatch: Function;

    /* @ngInject */
    constructor(private $rootScope: angular.IRootScopeService, private addressService: AddressService) {}

    $onInit() {
        this.$rootScope.$on("clever-match:schools", this.selectRecommendedCleverMatch);
        this.$rootScope.$on("clever-match:edit", this.editRecommendedOrSavedCleverMatch);
    }

    selectRecommendedCleverMatch = (_event, navianceSchool: NavianceSchool,
        cleverUnmatchSchools: CleverSchool[]) => {
            this.navianceSchool = angular.copy(navianceSchool);
            this.cleverSchool = undefined;
            this.searchFilterText = "";
            this.indexOfUnmatchedCleverSchool = null;
            this.cleverUnmatchedSchools = this.cleverUnmatchedSchools ? this.cleverUnmatchedSchools :
                angular.copy(cleverUnmatchSchools);
            this.$rootScope.$emit("drawer:open", "select-clever-match");
            this.setupEventListener();
    }

    editRecommendedOrSavedCleverMatch = (_event, navianceSchool: NavianceSchool,
        cleverSchool: CleverSchool, cleverUnmatchSchools: CleverSchool[]) => {
            this.navianceSchool = angular.copy(navianceSchool);
            this.cleverSchool = angular.copy(cleverSchool);
            this.searchFilterText = "";
            this.cleverUnmatchedSchools = this.cleverUnmatchedSchools ? this.cleverUnmatchedSchools :
                angular.copy(cleverUnmatchSchools);
            this.$rootScope.$emit("drawer:open", "select-clever-match");
            this.setupEventListener();
    }

    setupEventListener = () => {
        const element = document.querySelector(".ns-drawer");
        const closeElement = document.querySelector(".ns-icon--cancel");
        const eventHandler = (event) => {
            /* istanbul ignore next */
            if (event.target === element || event.target === closeElement) {
                this.closeDrawer();
                this.$rootScope.$apply();
                element.removeEventListener("click", eventHandler);
            }
        };
        element.addEventListener("click", eventHandler);
    }

    matchCleverSchool(clever:CleverSchool) {
        this.cleverSchool = clever;
        this.selectedNewCleverSchool = true;
    }

    unmatchCleverSchool(clever:CleverSchool) {
        this.cleverSchool = undefined;
        this.handleUnmatchedCleverSchoolsList(clever);
        this.indexOfUnmatchedCleverSchool = this.cleverUnmatchedSchools.indexOf(clever);
        this.onSchoolUnmatch(true);
    }

    isSchoolAlreadyInList(cleverSchool: CleverSchool): boolean {
        return this.cleverUnmatchedSchools.some(school => school === cleverSchool);
    }

    handleUnmatchedCleverSchoolsList(clever: CleverSchool): CleverSchool[] {
        if (this.isSchoolAlreadyInList(clever)) {
            return this.cleverUnmatchedSchools;
        }

        return this.cleverUnmatchedSchools = this.cleverUnmatchedSchools.concat(clever);
    }

    endCleverMatching() {
        if(this.selectedNewCleverSchool) {
            const indexOfCleverSchoolToBeMatched = this.cleverUnmatchedSchools.indexOf(this.cleverSchool);
            this.searchFilterText = "";
            if (indexOfCleverSchoolToBeMatched !== -1) {
                this.cleverUnmatchedSchools.splice(indexOfCleverSchoolToBeMatched, 1);
            }
        }
        this.$rootScope.$emit("clever-match:done", this.cleverSchool);
    }

    isCleverMatchAvailable(): boolean {
        return this.cleverSchool !== undefined;
    }

    closeDrawer() {
        if (this.indexOfUnmatchedCleverSchool) {
            this.cleverUnmatchedSchools.splice(this.indexOfUnmatchedCleverSchool, 1);
        }
        this.$rootScope.$emit("drawer:close", "select-clever-match");
    }

    getNavianceSchoolAddressLine(): string {
        return this.addressService.getNavianceSchoolAddressLine(this.navianceSchool);
    }

    getNavianceSchoolCityStateZip(): string {
        return this.addressService.getNavianceSchoolCityStateZip(this.navianceSchool);
    }

    getCleverSchoolAddress(cleverSchool: CleverSchool): string {
        return this.addressService.getCleverSchoolAddress(cleverSchool);
    }

    getCleverSchoolCityStateZip(cleverSchool: CleverSchool): string {
        return this.addressService.getCleverSchoolCityStateZip(cleverSchool);
    }

    searchFilter = (cleverSchool) => {
        const isSearchableByName = this.searchByName(cleverSchool);
        return isSearchableByName ? isSearchableByName :
            this.addressService.searchByAddress(cleverSchool, this.searchFilterText);
    }

    searchByName = (clever) => {
        return (clever.name.toLowerCase()).indexOf(this.searchFilterText.toLowerCase()) >= 0;
    }

    noCleverMatchedOrUnmatchedSchoolAvailable(): boolean {
        if (!this.cleverUnmatchedSchoolsList) { return false; }

        return !this.cleverUnmatchedSchoolsList.length && !this.isCleverMatchAvailable();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/match-details/match-details.controller.ts